let mod = null;

export async function loadXLSX() {
  if (mod) return mod;
  const loaded = await import('xlsx');
  mod = loaded.default ?? loaded;
  return mod;
}

export function parseWorkbookToTable(XLSX, workbook) {
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  const aoa = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: false, defval: '' });
  const headers = (aoa[0] || []).map((h) => String(h).trim());
  const rows = aoa
    .slice(1)
    .filter((r) => r.some((cell) => String(cell).trim() !== ''))
    .map((r) => headers.map((_, i) => String(r[i] ?? '')));
  return { headers, rows };
}
